<template>
  <div class="box">
    <h1 class="title is-4">Import {{ label }}</h1>

    <div class="field">
      <div class="file has-name is-boxed">
        <label class="file-label">
          <input class="file-input" type="file" @change="handleFile" />
          <span class="file-cta">
            <span class="file-label">Choose a file…</span>
          </span>
          <span class="file-name" v-if="file">{{ file.name }}</span>
        </label>
      </div>
    </div>

    <div class="field mt-3">
      <button class="button is-success" :disabled="!file" @click="uploadFile">
        Upload
      </button>
    </div>
  </div>
</template>

<script>
import api from '@/utils/axios';

export default {
  name: 'FileImport',
  props: {
    endpoint: { type: String, required: true }, // API endpoint
    label: { type: String, default: 'Data' }, // Title
    filename: { type: String, default: 'import_report.txt' }, // Default report name
  },
  data() {
    return {
      file: null,
    };
  },
  methods: {
    handleFile(e) {
      this.file = e.target.files[0];
    },
    async uploadFile() {
      if (!this.file) return;

      const formData = new FormData();
      formData.append('file', this.file);

      try {
        const res = await api.post(this.endpoint, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          responseType: 'blob', // expect a file back (.txt)
        });

        // Trigger download
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.filename);
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        console.error(err.response?.data || err);
        alert('Import failed. Check console for details.');
      }
    },
  },
};
</script>

<style scoped>
.box {
  max-width: 500px;
  margin: 0 auto;
}
</style>
